import {
	request
} from './request'
import {
	requestWx
} from './request'
const POST = 'POST';
const GET = 'GET';
const POSTA = 'POSTA';

export const order = {
	jpush(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		}
		return request(POST, 'xcx/order/jpush', params);
	},
	orderlist(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/order/order', params);
	},
	getordrnum(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/order/getordrnum', params);
	},
	detail(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/order/orderdetail', params);
	},
	casesinfo(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/user/casesinfo', params);
	},
	casestype(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/user/casestype', params);
	},
	invitat(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/order/invitat', params);
	},
	pay(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'index/order/pay', params);
	},
	caseslist(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/user/caseslist', params);
	},
	attend(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/order/attend', params);
	},
	getcalltoken(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/order/getcalltoken', params);
	},
	upnumber(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/order/upnumber', params);
	},
	usercall(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/order/usercall', params);
	},
	reject(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/order/reject', params);
	},
	serviceorder(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/order/serviceorder', params);
	},
	service_order(params,method) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, method, params);
	},
}
export const user = {
	visit(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		}
		return request(POST, 'xcx/user/visit', params);
	},
	changecase(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		}
		return request(POST, 'xcx/user/changecase', params);
	},
	usercases(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		}
		return request(POST, 'xcx/user/usercases', params);
	},
	addunionid(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		}
		return request(POST, 'xcx/Wxlgion/addunionid', params);
	},
	deletecases(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		}
		return request(POST, 'xcx/user/deletecases', params);
	},
	edicases(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/user/appedicases', params);
	},
	package(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/order/package', params);
	},
	cases(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/user/cases', params);
	},
	code(params) {
		return request(POST, 'xcx/Msg/userSms', params);
	},
	getcode(params) {
		return request(POST, 'xcx/Msg/sendSms', params);
	},
	loginfun(params) {
		return request(POST, 'xcx/Wxlgion/userlogin', params);
	},
	repwd(params) {
		return request(POST, 'xcx/Wxlgion/upporwd', params);
	},
	getUser(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/User/getUser', params);
	},
	upload(params) {
		return request(POSTA, 'xcx/Wxlgion/uploadHead', params, {
			'Content-Type': 'multipart/form-data'
		});
	},
	upuser(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/User/upuser', params);
	},
	focus(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/User/focus', params);
	},
	mypatient(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/User/mypatient', params);
	},
	canceluser(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/User/canceluser', params);
	},
	bill(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/User/bill', params);
	},
	recharge(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/user/recharge', params);
	},
	getintegral(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/user/getintegral', params);
	},
	register(params) {
		return request(POST, 'xcx//Wxlgion/userregister', params);
	},
}
export const index = {
	privacy(params) {
		return request(POST, 'xcx/Index/privacy', params);
	},
	article(params) {
		return request(POST, 'xcx/index/articlelist', params);
	},
	service(params) {
		return request(POST, 'xcx/index/service', params);
	},
	index(params) {
		return request(POST, 'xcx/Index/index', params);
	},
}
export const news = {
	artContent(params) {
		return request(POST, 'xcx/index/artContent', params);
	},
	article(params) {
		return request(POST, 'xcx/index/articlelist', params);
	},
}
export const doctor = {
	city(params) {
		return request(POST, 'xcx/index/city', params);
	},
	professional(params) {
		return request(POST, 'xcx/index/professional', params);
	},
	getlist(params) {
		return request(POST, 'xcx/index/doctor', params);
	},
	commentslist(params) {
		return request(POST, 'xcx/index/commentslist', params);
	},
	getdoctor(params) {
		return request(POST, 'xcx/index/doctordetail', params);
	},
	attent(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/user/coupons', params);
	},
	servicepackage(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/order/servicepackage', params);
	},
	cancoupons(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/user/cancoupons', params);
	},
	schedule(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/doctor/schedule', params);
	},
	doctorinfo(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/doctor/doctorinfo', params);
	},
	upload(params) {
		return request(POSTA, 'xcx/Wxlgion/upload', params, {
			'Content-Type': 'multipart/form-data'
		});
	},
	pay(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/Order/appaddorder', params);
	},
	doctorteam(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/index/doctorteam', params);
	},
	service_order(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/order/service_order', params);
	},
	package(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/doctor/package', params);
	},
	addpackge(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/order/addpackge', params);
	},
}
export const custome = {
	recoud(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/Custome/recoud', params);
	},
	getgroupinfo(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/Custome/getgroupinfo', params);
	},
	downrecoud(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/Custome/downrecoud', params);
	},
	index(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/Custome/index', params);
	},
	uprecoud(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/Custome/uprecoud', params);
	},
	getmoregroupinfo(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/Custome/getmoregroupinfo', params);
	},
	upgroupinfo(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/Custome/upgroupinfo', params);
	},
	upcoupons(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/Custome/upcoupons', params);
	},
	upcouponsa(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/Custome/upcouponsa', params);
	},
}
export const userchat = {
	isplay(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/Userchat/isplay', params);
	},
	recoud(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/Userchat/recoud', params);
	},
	getgroupinfo(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/Userchat/getgroupinfo', params);
	},
	downrecoud(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/Userchat/downrecoud', params);
	},
	index(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/Userchat/index', params);
	},
	uprecoud(params) {
		let token = localStorage.getItem('token');
		if (token) {
			params.token = token;
		} else {
			this.$router.push('/user/login');
		}
		return request(POST, 'xcx/Userchat/uprecoud', params);
	},
}



// WEBPACK FOOTER //
// ./src/api/index.js